import { render, staticRenderFns } from "./avatar-selector.vue?vue&type=template&id=3f8a8b81"
import script from "./avatar-selector.vue?vue&type=script&lang=js"
export * from "./avatar-selector.vue?vue&type=script&lang=js"
import style0 from "./avatar-selector.vue?vue&type=style&index=0&id=3f8a8b81&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports